import { __, copyToClipboard } from '../utils';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ButtonBase } from '@presov.sk/presov-ui-react';
import React from 'react';

const COPIED_MS = 1600;

/**
 * Kopírovateľná pilulka s identifikátorom - mono kód a ikonka kopírovania,
 * po kliknutí sa na chvíľu prepne na zelené „Skopírované".
 *
 * Je to tá istá vec, akú má detail podnetu vpravo hore ([[FeedDetail]]):
 * skopírovať kód je najčastejšia vec, ktorú s ním človek robí - hovorí ho
 * kolegovi alebo do podpory. Predtým bol identifikátor len v titule stránky
 * (`Hlasovanie: C4F7G2H`), odkiaľ sa nedal vybrať bez označovania textu.
 */
const CopyIdChip: React.FC<{ code: string; label?: string }> = ({
  code,
  label,
}) => {
  const [copied, setCopied] = React.useState(false);

  return (
    <ButtonBase
      onClick={() =>
        copyToClipboard(code, {
          onSuccess: () => {
            setCopied(true);
            window.setTimeout(() => setCopied(false), COPIED_MS);
          },
        })
      }
      title={label ?? __('Kopírovať ID')}
      sx={(theme) => ({
        flex: 'none',
        alignItems: 'center',
        gap: 0.75,
        height: theme.typography.pxToRem(theme.controlHeight.small),
        padding: theme.spacing(0, 1.25),
        borderRadius: `${theme.shape.borderRadius}px`,
        border: `${theme.typography.pxToRem(1)} solid ${
          copied ? theme.palette.green.light : theme.palette.divider
        }`,
        backgroundColor: copied
          ? theme.palette.green.surface
          : theme.palette.background.paper,
        color: copied ? theme.palette.green.dark : theme.palette.grey[500],
        fontSize: theme.typography.pxToRem(12),
        fontFamily: copied
          ? theme.typography.fontFamily
          : theme.typography.fontFamilyMono,
      })}
    >
      {copied ? __('Skopírované') : code}
      {copied ? (
        <CheckIcon sx={{ fontSize: 13 }} />
      ) : (
        <ContentCopyIcon sx={{ fontSize: 13 }} />
      )}
    </ButtonBase>
  );
};

export default CopyIdChip;
